export const BUILD_VERSION_HEADER = 'x-build-version';
export const LOCALE_HEADER = 'x-locale';
export const REDIRECT_URL_HEADER = 'x-redirect-url';
export const ROBOTS_TAG_HEADER = 'X-Robots-Tag'; // unsure about this capitalization
